import { Box } from '@mui/material'
import { Person, Shield } from '@mui/icons-material'

/** Filled shield + corner user badge (matches profile menu design). */
export function AdminPanelMenuIcon({ color }: { color: string }) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 24,
        height: 24,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Shield sx={{ fontSize: 22, color }} />
      <Box
        sx={{
          position: 'absolute',
          bottom: -1,
          right: -2,
          width: 12,
          height: 12,
          borderRadius: '50%',
          bgcolor: color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1.5px solid #fff',
          boxSizing: 'border-box',
        }}
      >
        <Person sx={{ fontSize: 8, color: '#fff' }} />
      </Box>
    </Box>
  )
}
